export const NAMESPACE = "SessionsSideBarSpace";

export const SIDEBAR_INSTANCE_ID = "sessions_sidebar_instance_id";

export const TAB_IDS = {
  DETAILS: "details",
  FILE_CONTENT: "file_content",
  TASKS: "tasks",
  PARTICIPANTS: "participants",
  SUBSESSIONS: "subsessions"
  // MESSAGES: "messages"
};

export const TABS = [
  {
    title: "Details",
    id: TAB_IDS.DETAILS
  },
  {
    title: "Files",
    id: TAB_IDS.FILE_CONTENT
  },
  {
    title: "Tasks",
    id: TAB_IDS.TASKS
  }
  // {
  //   title: "Messages",
  //   id: TAB_IDS.MESSAGES
  // }
];

export const TABS_ADVANCED_GROUP = [
  {
    title: "Details",
    id: TAB_IDS.DETAILS
  },
  {
    title: "Tasks",
    id: TAB_IDS.TASKS
  },
  {
    title: "Files",
    id: TAB_IDS.FILE_CONTENT
  },
  {
    title: "Participants",
    id: TAB_IDS.PARTICIPANTS
  },
  {
    title: "Subsessions",
    id: TAB_IDS.SUBSESSIONS
  }
];

export const FLYOVER_SESSION_FORM_ID = "SessionPageFormId";

export const FILE_STATUS = [
  {
    status: "approved",
    fileName: "informe_trimestral.pdf",
    fileType: "pdf"
  },
  {
    status: "pending",
    fileName: "presupuesto_2025.xlsx",
    fileType: "excel"
  },
  {
    status: "rejected",
    fileName: "propuesta_proyecto_revisada.docx",
    fileType: "word"
  },
  {
    status: "approved",
    fileName: "presentacion_cliente_revisada.pptx",
    fileType: "ppt"
  },
  {
    status: "pending",
    fileName: "contrato_nuevo_revisado.pdf",
    fileType: "pdf"
  },
  {
    status: "approved",
    fileName: "informe_anual.pdf",
    fileType: "pdf"
  },
  {
    status: "pending",
    fileName: "presupuesto_2024.xlsx",
    fileType: "excel"
  },
  {
    status: "rejected",
    fileName: "propuesta_proyecto.docx",
    fileType: "word"
  },
  {
    status: "approved",
    fileName: "presentacion_cliente.pptx",
    fileType: "ppt"
  },
  {
    status: "pending",
    fileName: "contrato_nuevo.pdf",
    fileType: "pdf"
  },
  {
    status: "approved",
    fileName: "informe_semestral.pdf",
    fileType: "pdf"
  },
  {
    status: "pending",
    fileName: "presupuesto_2023.xlsx",
    fileType: "excel"
  },
  {
    status: "rejected",
    fileName: "propuesta_proyecto_actualizada.docx",
    fileType: "word"
  },
  {
    status: "approved",
    fileName: "presentacion_cliente_actualizada.pptx",
    fileType: "ppt"
  },
  {
    status: "pending",
    fileName: "contrato_nuevo_actualizado.pdf",
    fileType: "pdf"
  },
  {
    status: "approved",
    fileName: "informe_cuatrianual.pdf",
    fileType: "pdf"
  },
  {
    status: "pending",
    fileName: "presupuesto_2022.xlsx",
    fileType: "excel"
  },
  {
    status: "rejected",
    fileName: "propuesta_proyecto_final.docx",
    fileType: "word"
  },
  {
    status: "approved",
    fileName: "presentacion_cliente_final.pptx",
    fileType: "ppt"
  },
  {
    status: "pending",
    fileName: "contrato_nuevo_final.pdf",
    fileType: "pdf"
  }
];

export const LOCATION_TYPE_IDS = {
  STAGE: "stage",
  ROOM: "room",
  BOOTH: "booth",
  NETWORKING: "networking",
  EXTERNAL: "external",
  BIDDING: "bidding",
  VIRTUAL: "virtual"
};

export const LOCATION_TYPES = [
  {
    id: LOCATION_TYPE_IDS.ROOM,
    label: "Room"
  },
  {
    id: LOCATION_TYPE_IDS.VIRTUAL,
    label: "Virtual"
  }
];

export const FIELD_IDS = {
  STATUS: "status",
  TAGS: "tags",
  LEVEL: "level",
  LANGUAGE: "language",
  CEU_CREDITS: "ceu_credits",
  TRACK: "track",
  FORMAT: "format",
  SPONSORS: "sponsors",
  EXHIBITORS: "exhibitors",
  SPEAKERS: "speakers",
  CHAIRPERSONS: "chairpersons",
  MODERATORS: "moderators",
  EMBEDS: "embeds",
  LOCATION: "location",
  BOOTH: "location_booth_id",
  ROOM: "location_room_id",
  LOCATION_ROOM: "location_room",
  STAGE: "location_stage_id",
  VIRTUAL: "session_location_type",
  LOCATION_EXTERNAL_URL: "location_external_url",
  SESSION_SUBMITTER: "session_submitter",
  CLIENT_SESSION_ID: "client_session_id",
  //
  TITLE: "title",
  DESCRIPTION: "description",
  STARTS_AT: "starts_at",
  ENDS_AT: "ends_at",
  BACKGROUND_IMAGE_URL: "background_image_url",
  VIDEO_URL: "video_url",
  VIDEO_TITLE: "video_title",
  CONFERENCE_URL: "conference_url",
  CONFERENCE_TITLE: "conference_title",
  TRANSCRIPT_URL: "transcript_url",
  REPLAY_URL: "replay_url",
  PARENTSESSIONID: "parentSessionId",
  FRIENDLY_ID: "friendlyId"
};

export const MODULES_TINY_MCE =
  "table media link code lists image codesample eqneditor wordcount";

export const FORMATS_TINY_MCE =
  "bold italic underline | superscript subscript link eqneditor | bullist numlist outdent indent | image | removeformat | code | codesample";
